import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { api, mediaUrl, sizedMediaUrl } from "../../lib/api";
import { useI18n } from "../../lib/i18n";

/**
 * Ana səhifədəki qalereya zolağı — yalnız admin-in "Ana səhifədə" seçdiyi
 * elementlər (GET /gallery?featured=true). Heç nə seçilməyibsə bölmə
 * özünü göstərmir.
 */
export default function GalleryStrip() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery", { params: { featured: true, limit: 8 } })
      .then((r) => setItems(r.data?.items || []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section className="adf-container py-16 lg:py-24" data-testid="home-gallery">
      <div className="mb-8 flex items-end justify-between gap-4 lg:mb-12">
        <div>
          <p className="uppercase tracking-[0.2em] text-[11px] text-[var(--adf-gray-3)] mb-3">
            {t("gallery.eyebrow", "Atelier lenti")}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl text-[var(--adf-ink)]">
            {t("gallery.title", "Qalereya")}
          </h2>
        </div>
        <Link
          to="/gallery"
          className="whitespace-nowrap text-[12px] font-semibold uppercase tracking-[0.1em] text-[var(--adf-ink)] underline underline-offset-8"
        >
          {t("gallery.view_all", "Hamısına bax")}
        </Link>
      </div>
      <div className="adf-gallery-strip">
        {items.map((item) => (
          <Link key={item.id} to="/gallery" className="adf-gallery-tile" aria-label={t("gallery.title", "Qalereya")}>
            {item.media_type === "video" ? (
              <>
                {/* 100MB+ fayl ana səhifəni yükləməsin: poster varsa video heç
                    nə çəkmir, tam axın yalnız qalereya lightbox-undadır. */}
                <video
                  src={mediaUrl(item.media_url)}
                  poster={item.poster_url ? sizedMediaUrl(item.poster_url, 720) : undefined}
                  muted
                  playsInline
                  preload={item.poster_url ? "none" : "metadata"}
                />
                <span className="adf-gallery-play" aria-hidden="true"><Play size={15} fill="currentColor" /></span>
              </>
            ) : (
              <img src={sizedMediaUrl(item.media_url, 720)} alt="" loading="lazy" />
            )}
          </Link>
        ))}
      </div>
    </section>
  );
}
